export default function installResonateLoader(window)
{
	const resonateAnalytics = window.resonateAnalytics = window.resonateAnalytics || [];
	if (resonateAnalytics.initialize)
	{
		return;
	}

	if (resonateAnalytics.invoked)
	{
		window.console && window.console.error && window.console.error("Resonate snippet included twice.");
		return;
	}

	resonateAnalytics.invoked = true;

	resonateAnalytics.methods =
	[
		"trackSubmit", "trackClick", "trackLink",
		"trackForm", "pageview", "identify", "reset",
		"group", "track", "ready", "alias", "debug",
		"page", "once", "off", "on", "profile"
	];

	resonateAnalytics.factory = function(type)
	{
		return function()
		{
			resonateAnalytics.push([type,...arguments]);
			return resonateAnalytics;
		}
	};

	resonateAnalytics.methods.forEach
	(
		function(method)
		{
			resonateAnalytics[method] = resonateAnalytics.factory(method);
		}
	);

	resonateAnalytics.load = function load()
	{
		const src = "https://cdn.resonate.com/analytics.js/v1/200302733/analytics.min.js";
		if(window.document.querySelector(`script[src="${src}"]`))
		{
			return;
		}

		const scriptTag = window.document.createElement("script");
		scriptTag.src = src;
		window.document.head.appendChild(scriptTag);
	};

	resonateAnalytics.SNIPPET_VERSION = "1.0.0";
}
